import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    contentArea: {
        height: '100%',
        overflowY: 'auto',
        padding: theme.spacing(1),
        paddingBottom: theme.spacing(11),
        flex: 1,
        position: 'relative',
    },
    qrText: {
        textAlign: 'center',
    },
    root: {
        display: 'flex',
        flexDirection: 'column',
        height: 600,
        backgroundColor: theme.palette.background.default,
        position: 'relative',
    },
    header: {
        padding: theme.spacing(2),
        borderBottom: `1px solid ${theme.palette.divider}`,
    },
    content: {
        flex: 1,
        overflow: 'hidden',
        padding: theme.spacing(2),
        position: 'relative',
    },
    listColumn: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    scrollableList: {
        flex: 1,
        overflowY: 'auto',
        padding: '2px',
    },
    footer: {
        padding: theme.spacing(2),
        borderTop: `1px solid ${theme.palette.divider}`,
    },
    cardContainer: {
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
    },
    cardContent: {
        display: "flex",
        flexGrow: 1,
        flexDirection: "column",
    },
    label: {
        fontSize: '0.9rem',
        color: '#9D9D9D',
        lineHeight: '14,1px',
        textAlign: 'justify',
        marginRight: '3px'
    },
    qrcode: {
        display: 'flex',
        flexDirection: "column",
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: theme.spacing(1)
    },
    buttonRemover: {
        borderColor: theme.palette.error.main,
        color: theme.palette.error.main,
        '& svg': {
            fill: theme.palette.error.main
        }
    },
    container: {
        overflowY: 'auto',
        height: 700
    },
    contentCliente: {
        borderRadius: theme.shape.borderRadius,
        border: `1px solid ${theme.palette.primary.main}`,
    },
    rootContainer: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        maxHeight: 'calc(100vh - 250px)',
        minHeight: 500,
    },
    footerArea: {
        padding: theme.spacing(2),
        position: 'absolute',
        bottom: 0,
        right: 0,
        left: 0,
        background: theme.palette.background.paper,
    },
    containerCadastro: {
        position: 'relative',
        minHeight: 600
    }
}));